import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --hank-image-max-height: calc(216rem / var(--default-rem-px-count));
    }

    /* One template for every content combination: children keep fixed rows
       (title/cta 2, description 3, images 4, text link 5) and unused
       minmax(0, auto) rows collapse to nothing. Keep it this way — a
       per-content-count row ladder drops children into the padding track
       whenever middle content is absent. */
    .hank-layout {
      grid-template-rows:
        var(--block-top-padding)
        repeat(4, minmax(0, auto))
        var(--block-bottom-padding)
        [last-line];
    }

    /* Title and button label share the top row's first baseline. */
    .block-title {
      grid-column: 2 / 5;
      grid-row: 2;
      align-self: baseline;
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .cta-btn {
      grid-column: 5 / 8;
      grid-row: 2;
      place-self: baseline end;
    }

    .block-description {
      grid-column: 2 / 8;
      grid-row: 3;
      margin-bottom: calc(40rem / var(--default-rem-px-count));
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .cta-text {
      grid-column: 2 / 8;
      grid-row: 5;
    }

    .images {
      display: flex;
      overflow-y: auto;
    }

    .image-container {
      display: flex;
      flex-direction: column;
    }

    .image-container > cta-text {
      padding-top: calc(6rem / var(--default-rem-px-count));
      /* .images sets overflow-y: auto, which per spec also clips overflow-x,
         so the cta-text hover underline (h3::after at bottom: -0.15em) would
         be cut off at the scroll edge. Reserve room so it can render. */
      padding-bottom: calc(6rem / var(--default-rem-px-count));
    }

    .image-container:not(:last-child) {
      margin-right: calc(32em / var(--default-rem-px-count));
    }

    .image {
      width: 100%;
      height: auto;
      max-height: var(--hank-image-max-height);
    }

    @media (min-width: 600px) {
      :host {
        --hank-image-max-height: calc(300rem / var(--default-rem-px-count));
      }

      .hank-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .block-title {
        grid-column: 2 / 6;
        grid-row: 2;
        margin-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .block-description {
        grid-column: 2 / 6;
        grid-row: 3;
        margin-bottom: calc(80rem / var(--default-rem-px-count));
      }

      .cta-btn {
        grid-column: 2 / 6;
        grid-row: 4;
        place-self: normal left;
      }

      .cta-text {
        grid-column: 2 / 6;
        grid-row: 4;
        place-self: normal left;
      }

      /* if both exist, bump the cta-text down a row */
      .cta-btn ~ .cta-text {
        grid-row: 5;
      }

      .images {
        grid-column: 7 / 14;
        grid-row: 2 / 5;
        max-width: 100%;
      }
    }

    @media (min-width: 1024px) {
      :host {
        --hank-image-max-height: calc(300rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1200px) {
      :host {
        --hank-image-max-height: calc(365rem / var(--default-rem-px-count));
      }
    }
  `,
];
